// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".6a0454ee859675d16bb994f6e86cdcad82a3dda1.chunk.js";
};